import styled from 'styled-components';

export const Discount = styled.div`
  width: fit-content;
  padding: 6px 19px 6px 19px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.green200};
  color: ${({ theme }) => theme.palette.green700};

  text-align: center;
  font-weight: 600;
  font-size: 10px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='3' ry='3' stroke='%232FBD14DB' stroke-width='3' stroke-dasharray='.5%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 4px;
`;
